import React from 'react';

import './cards-list-page.scss';
import CardsList from 'features/cards/components/cards-list/cards-list';

/**
 * List of cards associated to an account
 */
const CardsListPage = ({ modalType, contractNumber, accountLevel, includeTabs }) => {

  return <div className={'cards-list-page'}>
    <CardsList 
      modalType={modalType} 
      contractNumber={contractNumber} 
      accountLevel={accountLevel} 
      includeTabs={includeTabs} 
    />
  </div>;
};

export default CardsListPage;
